define('../app/fukit/view/common/pagination.view',['require','exports','module','uikit/uikit','templates','evicommon/spf/model/paginate','../../helpers/formatter','backbone.radio'],function(require, exports, module){
  //prettier-ignore
  var UIKit     = require('uikit/uikit'),
      Templates = require('templates'),
      Paginate  = require('evicommon/spf/model/paginate'),
      Formatter = require('../../helpers/formatter'),
      Radio     = require('backbone.radio');

  var PaginationView = UIKit.ItemView.extend({

      className: 'pagination',

      template: Templates.App['pagination'],

      options: {

      },

      internalViewOptions: {
        // pagination menu (page numbers)
        paginationMenuView: function () {
          return {
            type: UIKit.Pagination,
            bindings: {
              currentPage: Paginate.PAGE,
              totalPages: Paginate.TOTAL_PAGES,
            },
            model: this.model,
            dark: true,
            color: 'primary',
            alwaysShowEnds: true
          }
        },

        // pagination dropdown (page size)
        paginationDropdownView: {
          type: UIKit.Dropdown,
          direction: 'up',
          childBindings: {
            text: 'size'
          }
        },
        paginationCountView: {
          type: UIKit.Text
        }
      },

      modelEvents: {
        'change:size' : 'applyPageSize',
        'change' : 'applyCount'
      },

      initialize: function (options) {
        UIKit.ItemView.prototype.initialize.apply(this, arguments);

        this.paginationViewSetup();
      },

      applyPageSize: function () {
        var selectedItem = this.paginationDropdownView.collection.findWhere({ size: this.model.get(Paginate.SIZE) })
        var size = selectedItem ? selectedItem.get('size') : '0';
        this.paginationDropdownView.text = size + ' per page';
        this.paginationDropdownView.value = selectedItem;
      },

      applyCount: function() {
        this.paginationCountView.text = Radio.request('paginationService', 'pageCountTitle', this.model);
      },

      paginationViewSetup: function(sizes) {
        this.paginationDropdownView.collection = new Backbone.Collection(sizes || [{size: 5},{size: 10},{size: 25},{size: 50}]);
        this.paginationDropdownView.childBindings.text = 'size';

        this.applyPageSize();
        this.applyCount();

        // listen to changes in dropdown and apply value to paginate model
        this.listenTo(this.paginationDropdownView, 'change:value', function() {
          if (this.paginationDropdownView.value) {
            this.model.set(Paginate.SIZE, this.paginationDropdownView.value.get(Paginate.SIZE));
          } else {
            this.model.unset(Paginate.SIZE);
          }
          // reset page when the size changes
          this.model.set(Paginate.PAGE, 1);
        });

        this.listenTo(this.paginationMenuView, 'change', function() {
          this.applyCount.call(this);
        });
      }
  });

  module.exports = PaginationView;
})
;
